import React from 'react';
import { Badge } from './ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';
import { formatPrice, PROMO_TYPE_LABELS, PROMO_SCOPE_LABELS, formatDate } from '../lib/utils';

export default function PromoTag({ promotion, compact = false }) {
  if (!promotion) return null;

  const getLabel = () => {
    if (promotion.type === 'fixed_price') return formatPrice(promotion.value);
    if (promotion.type === 'percentage_off') return `-${promotion.value}%`;
    if (promotion.type === 'amount_off') return `-${formatPrice(promotion.value)}`;
    return 'Aktion';
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge
            variant="outline"
            className="bg-amber-50 text-amber-900 border-amber-200 text-[10px] font-medium cursor-help whitespace-nowrap"
            data-testid="promo-badge"
          >
            {compact ? '★' : promotion.name || getLabel()}
          </Badge>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs">
          <div className="text-xs space-y-1">
            <p className="font-semibold">{promotion.name}</p>
            <p>{PROMO_TYPE_LABELS[promotion.type]}: {getLabel()}</p>
            <p>{PROMO_SCOPE_LABELS[promotion.scope]}</p>
            {promotion.start_date && <p>Ab: {formatDate(promotion.start_date)}</p>}
            {promotion.end_date && <p>Bis: {formatDate(promotion.end_date)}</p>}
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
